import { SAND_CAT } from "../config";

export const getFileData = async (twinTag, version, token) => {
  const response = await fetch(
    `${SAND_CAT}/twinSchema/get?twinTag=${twinTag}&version=${version}`,
    {
      method: "GET",
      headers: {
        DeveloperAuthorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  if (!response.ok) {
    throw new Error("Failed to fetch file data");
  }

  return await response.json();
};

export const getFileList = async token => {
  const response = await fetch(`${SAND_CAT}/twinSchema/list`, {
    method: "GET",
    headers: {
      DeveloperAuthorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch file list");
  }

  return await response.json();
};

export const refreshFiles = async token => {
  const response = await fetch(`${SAND_CAT}/twinSchema/refreshCache`, {
    method: "POST",
    headers: {
      DeveloperAuthorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const responseData = await response.json();

  return response.ok && responseData.success;
};

export const deleteFiles = async (twinTag, token) => {
  const response = await fetch(`${SAND_CAT}/twinSchema/draft/delete`, {
    method: "POST",
    headers: {
      DeveloperAuthorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ twinTag: twinTag }),
  });

  const responseData = await response.json();

  return response.ok && responseData.success;
};

export const archiveFiles = async (twinTag, version, token) => {
  const response = await fetch(`${SAND_CAT}/twinSchema/archive`, {
    method: "POST",
    headers: {
      DeveloperAuthorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ twinTag: twinTag, version: version }),
  });
  const responseData = await response.json();

  return response.ok && responseData.success;
};

export const saveDraft = async (meta, script, token) => {
  const response = await fetch(`${SAND_CAT}/twinSchema/draft/save`, {
    method: "POST",
    headers: {
      DeveloperAuthorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ meta: meta, script: script }),
  });

  const responseData = await response.json();

  return response.ok && responseData.success;
};

export const publishDraft = async (twinTag, token) => {
  const response = await fetch(`${SAND_CAT}/twinSchema/publish`, {
    method: "POST",
    headers: {
      DeveloperAuthorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ twinTag }),
  });
  const responseData = await response.json();

  return response.ok && responseData.success;
};
